import { default as axios } from './axiosConfig'
import { getEnv } from '@utils/env'
import type { Allergy } from '@dataTypes/allergy-medical-condition.types'
import { logger } from '@utils/safeLogger'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PATIENT')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export const GetAllAllergies = async (options?: {
  accessToken?: string
  clinicId?: string
}): Promise<Allergy[]> => {
  try {
    const response = await axios.get<ApiResponse<{ allergies: Allergy[] }>>(
      `${BUSINESS_LAYER_API}/api/v1/allergy`,
      {
        headers: {
          ...(options?.accessToken
            ? { Authorization: `Bearer ${options.accessToken}` }
            : {}),
          ...(options?.clinicId ? { 'X-Clinic-ID': options.clinicId } : {}),
        },
      },
    )
    return response.data.data.allergies ?? []
  } catch (error) {
    logger.error('Error in GetAllAllergies:', error)
    throw error
  }
}
